import React, { FC } from "react";
import { Box, FormControl, List } from "@mui/material";
import TeamMembersDraggableListItem from "../DraggableTable/TeamMembersDraggableListItem";
import { Item } from "../../Helpers/typings";
import { CustomAsyncSelect } from "../CustomFields/CustomSelect";
import { Controller } from "react-hook-form";

export type Props = {
  items: Item[];
  onHandleOpenDialog?: (value: boolean) => void; // ✅ optional
  control: any;
  defaultOptions: any[];
  loadOptions: (inputValue: string) => Promise<any>;
  handleCreate: (value: string) => void;
  handleSelectChange: (selected: any) => void;
  onMoreClick: (event: React.MouseEvent<HTMLButtonElement>, item: Item) => void;
  popupId?: string;
};

const TeamMembersDraggableList: FC<Props> = React.memo(
  ({
    items,
    onHandleOpenDialog,
    control,
    defaultOptions,
    loadOptions,
    handleCreate,
    handleSelectChange,
    onMoreClick,
    popupId = "MAIN_OPD_POPUP",
  }) => {
    const onRowClick = () => {
      onHandleOpenDialog?.(true);
    };

    return (
      <>
        <List>
          {items
            .filter((row) => !row.isDeleted)
            .map((item: Item, index: number) => (
              <TeamMembersDraggableListItem
                key={item.procedureVisitTeamMemberId}
                item={item}
                index={item?.displayOrder}
                onRowClickForOpenDialog={onRowClick}
                onMoreClick={onMoreClick}
              />
            ))}
        </List>

        <Box sx={{ p: 2 }}>
          <FormControl fullWidth>
            <Controller
              name="teamMember"
              control={control}
              defaultValue={null}
              render={({ field }) => (
                <CustomAsyncSelect
                  {...field}
                  id="TeamMember"
                  FieldName="TeamMemberId"
                  defaultOptions={defaultOptions}
                  loadOptions={loadOptions}
                  placeholder="Add Team Member"
                  menuPortalTarget={
                    document.getElementById(popupId) || document.body
                  }
                  // createOptionLabel={`Create "${field?.value?.label || ""}"`}
                  onCreateOption={handleCreate}
                  handleChange={handleSelectChange}
                  className="text-input"
                />
              )}
            />
          </FormControl>
        </Box>
      </>
    );
  },
);

export default TeamMembersDraggableList;
